import 'slick-carousel';
import ProductCommentPopup from '../components/ProductCommentPopup';
import ImageZoom from 'js-image-zoom';
import ProductOffer from '../components/ProductOffer';

export default (function (w, d) {
    'use strict';

    function ProductController() {
        this.initCollapseToggles();
        this.initGallery();
        this.initLowerSlider();
        new ProductCommentPopup();
        new ProductOffer();
        new ProductOffer(false);
    }

    ProductController.prototype.initCollapseToggles = function () {
        const productCollapseToggles = document.querySelectorAll('.product-collapse-header .toggle');
        if (productCollapseToggles !== undefined) {
            productCollapseToggles.forEach(toggle => {
                toggle.addEventListener('click', () => {
                    const toggleParentBlock = toggle.parentElement.parentElement;
                    toggleParentBlock.querySelector('.product-collapse').classList.toggle('collapsed');
                })
            });
        }
    }

    ProductController.prototype.initGallery = function () {
        let zoomContainer = document.querySelector(".zoom-container");
        let options = {
            // width: 434,
            // height: 600,
            zoomWidth: 300,
            fillContainer: false,
            scale: 0.5,
            offset: {vertical: 50, horizontal: 272},
            zoomContainer: zoomContainer
        };

        new ImageZoom(document.getElementById("slider-item"), options);

        let ProductSlider = $('.product-gallery-slider');

        ProductSlider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            draggable: false,
            asNavFor: '.product-gallery-nav',
            prevArrow: "<button type='button' class='gallery-prev'><img src='/assets/build/images/icons/arrow-right-icon.svg'></button>",
            nextArrow: "<button type='button' class='gallery-next'><img src='/assets/build/images/icons/arrow-right-icon.svg'></button>",
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        dots: true,
                    },
                }
            ],
        });

        $('.product-gallery-nav').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            draggable: false,
            asNavFor: '.product-gallery-slider',
            arrows: false,
            centerMode: true,
            focusOnSelect: true,
        });

        ProductSlider.on('afterChange', function (event, slick, currentSlide) {
            new ImageZoom(document.querySelector(".slick-current .slider-item"), options);
        });
    }

    ProductController.prototype.initLowerSlider = function () {
        $('.product_slider').slick({
            centerMode: true,
            centerPadding: '0px',
            slidesToShow: 4,
            infinite: true,
            prevArrow: "<button type='button' class='slider-prev'><img class='clickable' style='transform: rotate(180deg);' src='/assets/build/images/icons/icon_arrow_big.svg'></button>",
            nextArrow: "<button type='button' class='slider-next'><img class='clickable' src='/assets/build/images/icons/icon_arrow_big.svg'></button>",
            responsive: [
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 2,
                        infinite: true,
                        prevArrow: "",
                        nextArrow: "",
                    }
                },
                {
                    breakpoint: 650,
                    settings: {
                        slidesToShow: 2,
                        infinite: true,
                    }
                },
                {
                    breakpoint: 850,
                    settings: {
                        infinite: true,
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 1500,
                    settings: {
                        infinite: true,
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        infinite: true,
                        slidesToShow: 3,
                    }
                }
            ]
        });
    }

    return ProductController;
}(window, document));

